import { atom } from "jotai";

// Command Dialog open / close state
export const isCommandOpenAtom = atom(false);

// Toggle Command Dialog state
export const toggleCommandOpenAtom = atom(null, (get, set) =>
	set(isCommandOpenAtom, !get(isCommandOpenAtom)),
);

// Set Command Dialog state true or false
export const setCommandOpenAtom = atom(null, (_, set, open: boolean) =>
	set(isCommandOpenAtom, open),
);
